import { createUseStyles } from 'react-jss'
import { colors } from '../../common/colors'

export const borderStyle = `1px solid ${colors.borderGray}`
export const paddingRight = 10

export const style = {
  table: {
    fontSize: 14,
    margin: '0 auto'
  },
  rowsWithoutSection: {
    borderLeft: borderStyle,
    borderRight: borderStyle
  }
}

export const useStyles = createUseStyles(style)
